import { useState } from "react"

import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Button from "../../../../Components/Button"
import ExportDropdown from "../../../../Components/Export"
import Icon from "../../../../Icon"
import { FaqStub } from "../FaqStub"

// §BLOCK 1.2 — "Learn more about Digital Receipt" button (Header right side).
// Реєструється в TitleSectionContext з ReceiptPage/index.js.
const LearnMoreAction = ({ isMobile, isAdminPage, isActive, isDemo, canExport, onExport }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const { exportFetching } = useSelector((s) => s.receipt)

  return (
    <>
      {open && <FaqStub isMobile={isMobile} open={open} onClose={() => setOpen(false)} />}

      {/* ACTIONS */}
      <Button
        type="default"
        icon={<Icon type="question_help" style={isMobile ? {} : { fontSize: 16 }} />}
        onClick={() => setOpen(true)}
      >
        {!isMobile && t("Learn more about Digital Receipt")}
      </Button>

      {isMobile && isActive && canExport && (
        <ExportDropdown
          loading={exportFetching}
          onExport={onExport}
          isAdmin={isAdminPage}
          disabled={isDemo}
          iconButton
          inHeader
        />
      )}
    </>
  )
}

export default LearnMoreAction
